import { render, staticRenderFns } from "./platform.vue?vue&type=template&id=35ba917c&scoped=true"
import script from "./platform.vue?vue&type=script&lang=js"
export * from "./platform.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/popUp.scss?vue&type=style&index=0&id=35ba917c&prod&lang=scss&scoped=true&external"
import style1 from "@/assets/css/tableList.scss?vue&type=style&index=1&id=35ba917c&prod&lang=scss&scoped=true&external"
import style2 from "./platform.vue?vue&type=style&index=2&id=35ba917c&prod&lang=scss&scoped=true"
import style3 from "./platform.vue?vue&type=style&index=3&id=35ba917c&prod&lang=css"
import style4 from "./platform.vue?vue&type=style&index=4&id=35ba917c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ba917c",
  null
  
)

export default component.exports